// CustomAccordion.js
import React from 'react';
import '../assets/scss/Accordion.scss'; // Import the CSS file for the accordion
const Accordion = ({  id, title, isOpen, onToggle, children }) => {

  return (
    <div className="accordion">
      <div className="accordion-header" onClick={() => onToggle(id)}>
        <p className='header-text'>{title}</p>
        <span>{isOpen ? '−' : '+'}</span>
      </div>
      {isOpen && (
        <div style={{ textAlign: "center" }} className="accordion-body">
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;
